import { useState } from "react";
import { colors, fontFamily } from "../styles";
import { initialsFor } from "../format";

/**
 * Profile image with an initials fallback. Falls back on a load error too, not
 * just an empty URL — plenty of stored profilePicURLs point at dead objects,
 * and a broken-image glyph in every other table row looks like the dashboard
 * is broken rather than the photo.
 */
const Avatar = ({
  url,
  fullName,
  username,
  size = 28,
}: {
  url: string;
  fullName: string;
  username: string;
  size?: number;
}) => {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(url) && !failed;

  if (showImage) {
    return (
      <img
        src={url}
        alt=""
        onError={() => setFailed(true)}
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          objectFit: "cover",
          flexShrink: 0,
          background: colors.surfaceMuted,
        }}
      />
    );
  }

  return (
    <div
      aria-hidden
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        flexShrink: 0,
        background: colors.surfaceMuted,
        border: `1px solid ${colors.border}`,
        color: colors.inkMuted,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily,
        fontSize: Math.max(10, Math.round(size / 2.6)),
        fontWeight: 600,
      }}
    >
      {initialsFor(fullName, username)}
    </div>
  );
};

export default Avatar;
